
import Vue from 'vue'
import { extractErrorMessage } from '@/utils/Util';

export default Vue.extend({
    name: 'NotesListDialog',

    props: {
        notes: { type: Array, default: () => [] },
        edit: { type: Boolean, default: false },
    },

    data: (vm: any): any => ({
        showCreateForm: false,
        newNoteBody: "",
        newNoteVisibility: "PUBLIC",
        createValid: false,
        creating: false,
        editingNote: null as any,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        visibilityItems: ["PUBLIC", "ADMIN_ONLY"],
        requiredRule: [(v: string) => !!v || vm.$t('required')],
    }),

    computed: {
        sortedNotes(): any[] {
            return [...(this.notes as any[])].sort((a: any, b: any) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
        },
    },

    methods: {
        cancelCreate() {
            this.showCreateForm = false;
            this.newNoteBody = "";
            this.newNoteVisibility = "PUBLIC";
            this.alertVisible = false;
        },
        async onCreate() {
            if(!(this.$refs.createForm as any).validate()) return;
            this.creating = true;
            try {
                this.$emit('create:note', { body: this.newNoteBody, visibility: this.newNoteVisibility });
                this.cancelCreate();
            } catch(err: any) {
                this.alertType = "error";
                this.alertText = extractErrorMessage(err);
                this.alertVisible = true;
            }
            this.creating = false;
        },
        startEdit(note: any) {
            this.editingNote = { ...note };
        },
        onSaveEdit(note: any) {
            this.$emit('update:note', { uuid: note.uuid, body: this.editingNote.body });
            this.editingNote = null;
        },
        onDelete(note: any) {
            this.$emit('delete:note', note);
        },
    },
})
